import ApplicationAdapter from './application';

export default class VisualComplianceConfigurationAdapter extends ApplicationAdapter {
  pathForType() {
    return 'visual-compliance-configurations';
  }
}
